import gql from 'graphql-tag';
import { firstValueFrom } from 'rxjs';
import { addActionBarItem, ModalService } from '@vendure/admin-ui/core';
import { map, catchError, switchMap } from 'rxjs/operators';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { Observable, EMPTY } from 'rxjs';

const mutation = gql`
    mutation VoidPayment($orderId: ID!) {
        voidPayment(orderId: $orderId)
    }
`;

const query = gql`
    query CheckVoidablePayment($orderId: ID!) {
        checkVoidablePayment(orderId: $orderId)
    }
`;

export default [
    addActionBarItem({
        id: 'void_button',
        label: 'Void Payment',
        locationId: 'order-detail',
        icon: 'ban',
        buttonColor: 'primary',
        requiresPermission: 'UpdateOrder',
        buttonState: context => {
            const orderId = context.route.snapshot.params.id;
            return context.dataService
                .query<{ checkVoidablePayment: boolean }>(query, { orderId })
                .mapSingle(response => response.checkVoidablePayment)
                .pipe(
                    map(state => ({
                        disabled: !state,
                        visible: state,
                    })),
                );
        },
        onClick: async (event, context) => {
            try {
                context.injector
                    .get(ModalService)
                    .dialog({
                        title: 'Are you sure you want to void this payment?',
                        buttons: [
                            { type: 'secondary', label: _('common.cancel') },
                            { type: 'danger', label: 'Void', returnValue: true },
                        ],
                    })
                    .pipe(
                        switchMap(response =>
                            response
                                ? context.dataService.mutate(mutation, {
                                      orderId: context.route.snapshot.params.id,
                                  })
                                : EMPTY,
                        ),
                    )
                    .subscribe({
                        next: (response: any) => {
                            if (response.voidPayment) {
                                context.notificationService.success('Payment voided');
                                window.location.reload();
                            } else {
                                context.notificationService.error('Could not void payment');
                            }
                        },
                        error: () => {
                            context.notificationService.error('Could not void payment');
                        },
                    });
            } catch (error) {
                context.notificationService.error('Could not void payment');
            }
        },
    }),
];
